import React, { useRef, useState } from "react";
import { DefaultDropdown } from "../../_helpers/components/Forms/Dropdown";
import { InputForm } from "../../_helpers/components/Forms/InputLabel";
import { CreateAdminAccount } from "../../_api/Admin";
import { Button } from "../../_helpers/components/Button";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Toggle } from "../../_helpers/components/Forms/ToggleButton";
import { validateEmail, validatePhone } from "../../_helpers/functions";

const Register = () => {
    const navigate = useNavigate();

    const [registerStep, setRegisterStep] = useState(0);
    const [establishmentNumber, setEstablishmentNumber] = useState("");
    const [employesNumber, setEmployesNumber] = useState("");
    const [holderPosition, setHolderPosition] = useState("");
    const [companyActivity, setCompanyActivity] = useState("");
    const [companyCountry, setCompanyCountry] = useState("");
    const [isFranchise, setFranchise] = useState(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const [mobile, setMobile] = useState("");
    const [mail, setMail] = useState("");
    const [companyName, setCompanyName] = useState("");

    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [error, setError] = useState("");
    const [isRegistering, setIsRegistering] = useState(false);
    const registeringRef = useRef(false);

    const registerUser = (e) => {
        e.preventDefault();
        if (registeringRef.current) {
            return;
        }
        registeringRef.current = true;
        const payload = {
            establishmentNumber,
            employesNumber,
            holderPosition,
            companyActivity,
            companyCountry,
            isFranchise,
            name: companyName,
            first_name: firstName,
            last_name: lastName,
            password: password,
            mobile: mobile,
            email: mail,
        };

        setIsRegistering(true);
        CreateAdminAccount(payload)
            .then((resp) => {
                navigate("/login");
                toast("Un email vous a été envoyé pour valider votre inscription.");
            })
            .catch((resp) => {
                toast(resp.response.data.message);
            })
            .finally(() => {
                registeringRef.current = false;
                setIsRegistering(false);
            });
    };

    const FirsStep = (e) => {
        e.preventDefault();

        if(!validateEmail(mail)) {
            toast("L'adresse mail est incorrecte");
            return;
        }

        if(!validatePhone(mobile)) {
            toast("Numéro de téléphone invalide");
            return;
        }

        if (password !== password2) {
            toast("Les mots de passes ne sont pas identiques");
            return;
        }

        if (password.length <= 6) {
            toast("Le mot de passe doit faire au minimum 6 caractères");
            return;
        }

        if (
            (companyName.length >= 2,
                firstName.length >= 2,
                lastName.length >= 2,
                password.length >= 6)
        ) {
            setRegisterStep(1);
        } else {
            toast("Tous les champs sont obligatoires");
            return;
        }
    };

    return (
        <div className="self-center border shadow round-lg m-auto p-4 bg-white leading-8">
            <h5 className="italic mb-3">Créer un compte gratuit en deux étapes</h5>
            {registerStep === 1 && (
                <>
                    {/* <InputForm
                        set={() => setFranchise(!isFranchise)}
                        className="text-left"
                        classNameWrapper="inline block"
                        name="Etes-vous franchisé ?"
                        type="checkbox"
                        value={isFranchise}
                    /> */}
                    <div className="flex gap-4 mb-3">
                        <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">
                            Etes-vous franchisé ?
                        </label>
                        <Toggle
                            enabled={isFranchise}
                            setEnabled={setFranchise}
                            name={""}
                            required={true}
                        />
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <DefaultDropdown
                                name="# d'établissements"
                                value={establishmentNumber}
                                onChange={(e) =>
                                    setEstablishmentNumber(e.target.value)
                                }
                                options={[
                                    "",
                                    "0",
                                    "1",
                                    "2-5",
                                    "6-20",
                                    "+ de 20",
                                ]}
                            />
                        </div>
                        <div className="w-full md:w-1/2 px-3">
                            <DefaultDropdown
                                name="# de salariés"
                                value={employesNumber}
                                onChange={(e) =>
                                    setEmployesNumber(e.target.value)
                                }
                                options={[
                                    "",
                                    "0-5",
                                    "6-10",
                                    "11-15",
                                    "16-30",
                                    "31-80",
                                    "+ de 80",
                                ]}
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <DefaultDropdown
                            name="Poste exercé"
                            value={holderPosition}
                            onChange={(e) => setHolderPosition(e.target.value)}
                            options={[
                                "",
                                "Gérant",
                                "Ressources Humaines",
                                "Opérations",
                                "Manager",
                                "Consultant",
                                "Etudiant",
                                "Employé",
                                "Autre",
                            ]}
                        />
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full md:w-1/2 px-3">
                            <DefaultDropdown
                                name="Activité"
                                value={companyActivity}
                                onChange={(e) =>
                                    setCompanyActivity(e.target.value)
                                }
                                options={[
                                    "",
                                    "Restauration",
                                    "Hotellerie",
                                    "Boulangerie",
                                    "Alimentaire",
                                    "Santé/Pharmacie",
                                    "Retail/Boutique",
                                    "Loisirs et sports",
                                    "Services",
                                    "Autres",
                                ]}
                            />
                        </div>
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <DefaultDropdown
                                name="Pays"
                                value={companyCountry}
                                onChange={(e) =>
                                    setCompanyCountry(e.target.value)
                                }
                                options={[
                                    "",
                                    "France",
                                    "Belgique",
                                    "Espagne",
                                    "Portugal",
                                ]}
                            />
                        </div>
                    </div>
                </>
            )}
            {registerStep === 0 && (
                <>
                    <InputForm
                        set={setCompanyName}
                        name="Nom de société :"
                        placeholder="Nom de la société"
                        type="text"
                        value={companyName}
                        required={true}
                    />
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <InputForm
                                set={setLastName}
                                name="Nom :"
                                placeholder="Nom"
                                type="text"
                                value={lastName}
                                required={true}
                            />
                        </div>
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <InputForm
                                set={setFirstName}
                                name="Prénom :"
                                placeholder="Prénom"
                                type="text"
                                value={firstName}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <InputForm
                                set={setMobile}
                                name="Téléphone :"
                                placeholder="00 00 00 00 00"
                                type="text"
                                value={mobile}
                                required={true}
                            />
                        </div>
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <InputForm
                                set={setMail}
                                name="Email :"
                                placeholder="exemple@domaine.fr"
                                type="email"
                                value={mail}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap -mx-3 mb-3">
                        <div className="w-full px-3 md:mb-0">
                            <InputForm
                                set={setPassword}
                                name="Nouveau mot de passe :"
                                type="password"
                                value={password}
                                placeholder="Mot de passe ..."
                                required={true}
                            />
                        </div>
                        <div className="w-full px-3 md:mb-0">
                            <InputForm
                                set={setPassword2}
                                name="Confirmation du mot de passe :"
                                type="password"
                                value={password2}
                                placeholder="Confirmation mot de passe..."
                                required={true}
                            />
                        </div>
                        {error && (
                            <p className="text-left text-red-500 text-xs italic">
                                {error}
                            </p>
                        )}
                    </div>
                </>
            )}
            <div className="flex items-center justify-between mt-3">
                {registerStep === 1 && (
                    <Button
                        action={() => setRegisterStep(0)}
                        name={"Retour"}
                        type={"empty"}
                    />
                )}
                {registerStep === 0 ? (
                    <Button action={FirsStep} name={"Suivant"} />
                ) : (
                    <Button
                        action={(e) => {
                            e.preventDefault();
                            if (
                                establishmentNumber !== "" &&
                                employesNumber !== "" &&
                                holderPosition !== "" &&
                                companyActivity !== "" &&
                                companyCountry !== ""
                            ) {
                                registerUser(e);
                            } else {
                                toast("Tous les champs sont obligatoires");
                            }
                        }}
                        loading={isRegistering}
                        name={"S'inscrire"}
                    />
                )}
            </div>
        </div>
    );
};

export default Register;
